{
  "sdk-download-android": "Download for Android",
  "sdk-connect": "Connect",
  "sdk-download-ios": "Download for iOS",
  "sdk-install": "Install",
  "sdk-modal-instruct-1": "1. Open Binance app",
  "sdk-modal-instruct-2": "2. Tap {{icon}} on Home Screen",
  "sdk-modal-title": "Connect With Binance",
  "sdk-no-app": "Don’t have the Binance app yet?"
}